import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MCheckoutRequest } from 'src/app/pages/checkout-new/checkout-new.module';
import { SharedPrefrences, UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsCheckoutService {

  constructor(private httpClient: HttpClient) { }

  /**
 * Date:- 13-06-2023
 * Method :- This method is used to place order 
 * @param mCheckoutRequest :-  This is used for place order 
 * @returns 
 */
  placeOrder(mCheckoutRequest: MCheckoutRequest): Observable<any> {
    var jsonBody = JSON.stringify(mCheckoutRequest)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.PLACEORDER, mCheckoutRequest, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  getDiscount(discount_code: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETDISCOUNT + "?discount_code=" + discount_code + '&userId=' + SharedPrefrences.getUserId(), httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  getAllDiscount(discountFilter: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETAllDISCOUNT , discountFilter, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
  getAllDiscountByProductIds(productIds: any,brandIds?: any , categoryIds?:any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<any>(UtilsService.BASE_URL + UtilsService.GETAllDISCOUNTBYPRODUCTIDS + '?ProductIds=' + productIds + '&BrandIds=' + brandIds + '&CategoryIds=' + categoryIds, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  getAllDiscountByProductId(productIds: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<any>(UtilsService.BASE_URL + UtilsService.GETAllDISCOUNTBYPRODUCTIDS + '?ProductIds=' + productIds, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  getAllBrandTypeMappingByProductId(data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETHIGHLIGHTSRECOMMENDS ,data, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  getAllDiscountCatelogue(mCommonListModalRequest: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETAllDISCOUNTCATELOGUE ,mCommonListModalRequest, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

}
